export enum LayerIds {
  LASSO_SELECTION_POLYGON = 'lasso-selection-polygon',
  ROUTES_POLYLINES = 'routes-polylines',
  ROUTES_PRIMARY = 'routes-colored',
  ROUTES_OUTLINE = 'routes-outline',
  START_END = 'start-end',
  STOP_MARKERS = 'stop-markers',
  STOP_SCATTERPLOT_PENDING = 'visits-scatterplot-pending',
  STOP_SCATTERPLOT_SCHEDULED = 'visits-scatterplot',
  STOP_SCATTERPLOT_DRAG = 'dragging-visit-scatterplot',
  STOP_SCATTERPLOT_UNSCHEDULED = 'unscheduled-visits',
  STOP_SCATTERPLOT_SUGGESTIONS = 'visit-suggestions',
  ORDER_ATTEMPT_LOCATION = 'order-attempt-location',
  POLYGON_SELECTION = 'polygon-selection',
  DRAW_ROUTE = 'draw-route',
}

export enum LassoMode {
  DRAWPOLYGON = 'polygon',
  EDITING = 'editing',
}

export const GREY_RGB = [169, 169, 169];
export const COBALT_RGB = [39, 85, 233];
export const COBALT_FILL_RGB = [30, 66, 181];
export const WHITE_RGB = [255, 255, 255];

export const SELECTED_LINE_WIDTH = 4;
export const UNSELECTED_LINE_WIDTH = 3;

export const DRAGGING_OFFSET = [0, 2];
export const NONDRAGGING_OFFSET = [0, 0];

export const DRAGGING_SHADOW_RADIUS = 12;
export const SELECTED_SHADOW_RADIUS = 6;

// Enlarges the unscheduled-order scatterplot dots relative to the base radius. Shared by the
// scheduling map's unscheduled layer and the orders map so both render unscheduled dots at one size.
export const UNSCHEDULED_STOP_RADIUS_MULTIPLIER = 1.5;

export enum CursorTooltipStatus {
  PREDRAW_LASSO = 'preDraw',
  CLOSING_LASSO = 'closingLasso',
  REASSIGN_HELPER = 'reassignHelper',
}

export const DEFAULT_EMPTY_FEATURE_COLLECTION = {
  type: 'FeatureCollection',
  features: [],
};

/** *
 * List of EditTypes available at
 * https://nebula.gl/docs/api-reference/layers/editable-geojson-layer
 */
export enum MapEditType {
  MOVE_POSITION = 'movePosition',
  ADD_POSITION = 'addPosition',
  ADD_TENTATIVE_POSITION = 'addTentativePosition',
  REMOVE_POSITION = 'removePosition',
  ADD_FEATURE = 'addFeature',
  FINISH_MOVE_POSITION = 'finishMovePosition',
}

export enum LassoEditHandleType {
  EXISTING = 'existing',
  INTERMEDIATE = 'intermediate',
}

export enum LassoGuideType {
  TENTATIVE = 'tentative',
  EDIT_HANDLE = 'editHandle',
}
